import { Component } from '@angular/core';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
  standalone: true,
  selector: 'pm-form-field-switch',
  imports: [ToggleSwitchModule, ReactiveFormsModule, CommonModule],
  templateUrl: './pm-form-field-switch.component.html',
  styleUrl: './pm-form-field-switch.component.scss',
})
export class PmFormFieldSwitchComponent extends FormFieldComponent {}
